/**
 * The single mock-mode switch, kept apart from the mock stores so the main
 * chunk (accSession) can read it without pulling seed data along.
 *
 * Dev defaults to the real backend; mock is opt-in:
 *   - build/start time:  REACT_APP_KNOWLEDGE_MOCK=true npm start
 *   - at runtime:        localStorage.setItem('kb_mock', 'true'); location.reload();
 *   - disable runtime:   localStorage.removeItem('kb_mock'); location.reload();
 * Production never serves mock unless explicitly opted in via those flags.
 */

const FORCE_MOCK_IN_DEV = false;

const isProduction = () => {
    try {
        return typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
    } catch (e) {
        return false;
    }
};

const envMockEnabled = () => {
    try {
        return typeof process !== 'undefined' && process.env && process.env.REACT_APP_KNOWLEDGE_MOCK === 'true';
    } catch (e) {
        return false;
    }
};

const localStorageFlag = () => {
    try {
        if (typeof window === 'undefined') return null;
        return window.localStorage.getItem('kb_mock');
    } catch (e) {
        return null;
    }
};

export const isMockMode = () => {
    // Explicit localStorage opt-in/out always wins (lets you test the real
    // backend in dev with kb_mock="false", or enable mock in prod with "true").
    const flag = localStorageFlag();
    if (flag === 'true') return true;
    if (flag === 'false') return false;

    if (envMockEnabled()) return true;

    return !isProduction() && FORCE_MOCK_IN_DEV;
};
